import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";

const useStyles = makeStyles(() => ({
  signedCompleteContainer: {
    marginTop: "3.25rem",
  },
}));

const QESSignerUserDetails = (props) => {
  const { stageStatus, initiatedByUser, signedDate } = props.signingStatus;
  const { halterFormValues } = props;

  const addressDocumentVerifiedOnValue =
    halterFormValues?.addressDocumentVerifiedOn?.value;

  const { signedCompleteContainer } = useStyles();

  return (
    <div className={signedCompleteContainer}>
      <p>
        Ich habe die Halteradresse anhand eines amtlichen Dokuments (z. B.
        Personalausweis) geprüft und bestätige die Übereinstimmung.
      </p>
      <p>Geprüft durch: {initiatedByUser}</p>
      {addressDocumentVerifiedOnValue && (
        <p>
          Geprüft am:{" "}
          {moment(addressDocumentVerifiedOnValue).format("DD.MM.YYYY")} um{" "}
          {moment(addressDocumentVerifiedOnValue).format("HH:mm")} Uhr
        </p>
      )}

      {stageStatus === "completed" && (
        <p>
          Signierte Dokumente empfangen am:{" "}
          {moment(signedDate).format("DD.MM.YYYY")} um{" "}
          {`${moment(signedDate).format("HH:mm")} Uhr`}
        </p>
      )}
    </div>
  );
};

export default QESSignerUserDetails;
